// Define GTM events
// Object must be in the format of { [page_name]: { [event_name]: "event_name" } }
export const gtm = {
  pricing: {
    visited: "pricing_page_visited",
    discount_popup_visible: "pricing_discount_popup_visible",
    discount_popup_close: "pricing_discount_popup_close",
  },
  homePage: {
    download_btn_clicked: "home_page_download_button_clicked",
    download_btn_visible: "home_page_download_button_visible",
    download_dropdown_visible: "home_page_download_dropdown_visible",

    dropdown_signup_by_email_btn: "home_page_dropdown_signup_by_email_btn",

    dropdown_signup_by_google_btn: "home_page_dropdown_signup_by_google_btn",
    dropdown_signup_by_google: "home_page_dropdown_signup_by_google",

    dropdown_signup_by_azure_btn: "home_page_dropdown_signup_by_azure_btn",
    dropdown_signup_by_azure: "home_page_dropdown_signup_by_azure",

    popup_signup_by_email_btn: "home_page_popup_signup_by_email_btn",
    popup_signup_by_email: "home_page_popup_signup_by_email",

    popup_signup_by_google_btn: "home_page_popup_signup_by_google_btn",
    popup_signup_by_google: "home_page_popup_signup_by_google",

    popup_signup_by_azure_btn: "home_page_popup_signup_by_azure_btn",
    popup_signup_by_azure: "home_page_popup_signup_by_azure",

    popup_signup_visible: "home_page_popup_signup_visible",
  },
  login: {
    visited: "login_page_visited",
    try_login: "login_page_try_login",
    any_error: "login_page_any_error",
    email_error: "login_page_email_error",
    password_error: "login_page_password_error",
    login_success: "login_page_login_success",

    google_login_try: "login_page_google_login_try",
    google_login_success: "login_page_google_login_success",
    google_login_error: "login_page_google_login_error",

    azure_login_try: "login_page_azure_login_try",
    azure_login_success: "login_page_azure_login_success",
    azure_login_error: "login_page_azure_login_error",

    expired_visited: "login_page_expired_visited",
    expired_try_login: "login_page_expired_try_login",
    expired_any_error: "login_page_expired_any_error",
    expired_email_error: "login_page_expired_email_error",
    expired_password_error: "login_page_expired_password_error",
    expired_login_success: "login_page_expired_login_success",

  },
  passwordRecovery: {
    visited: "password_recovery_page_visited",
    try_reset: "password_recovery_page_try_reset",
    any_error: "password_recovery_page_any_error",
    email_error: "password_recovery_page_email_error",
    reset_link_success: "password_recovery_page_reset_link_success",
  },
  newPassword: {
    visited: "new_password_page_visited",
    try_reset: "new_password_page_try_reset",
    any_error: "new_password_page_any_error",
    password_error: "new_password_page_password_error",
    token_error: "new_password_page_token_error",
    reset_success: "new_password_page_reset_success",
  },
  autoLogin: {
    visited: "auto_login_page_visited",
    try_login: "auto_login_page_try_login",
    login_success: "auto_login_page_login_success",
    any_error: "auto_login_page_any_error",
  },
  register: {
    visited: "register_page_visited",
    try_register: "register_page_try_register",
    any_error: "register_page_any_error",
    email_error: "register_page_email_error",
    password_error: "register_page_password_error",
    register_success: "register_page_register_success",

    google_register_try: "register_page_google_register_try",
    google_register_success: "register_page_google_register_success",

    azure_register_try: "register_page_azure_register_try",
    azure_register_success: "register_page_azure_register_success",

    register_after_login_error: "register_page_register_after_login_error",
    register_after_auto_login_error: "register_page_register_after_auto_login_error",
  },
  dashboard: {
    visited: "dashboard_page_visited",
    download_popup: {
      seen: "download_popup_seen",
      closed: "download_popup_closed",
      download_btn_clicked: "download_btn_clicked",
    },
  },
  billing: {
    manage_btn_clicked: "billing_manage_btn_clicked",
    cancel_subscription_popover_seen: "billing_cancel_sub_popover_seen",
    see_other_plans_clicked: "billing_popover_see_other_plans_clicked",
    disable_auto_renew_clicked: "billing_popover_disable_auto_renew_clicked",
    contact_us_clicked: "billing_popover_contact_us_clicked",
    churnkey_seen: "billing_churnkey_seen",
  },
  cancelSubscription: {
    cancel_btn_clicked: "cancel_subscription_cancel_btn_clicked",
    continue_btn_clicked: "cancel_subscription_continue_btn_clicked",
  },
  checkout: {
    visited: "checkout_page_visited",
  },
};
